import { UserAddOutlined } from '@ant-design/icons';
import { type NodeProps } from '@xyflow/react';
import UserUpdateMenu from 'automations/components/Nodes/UserUpdateMenu';
import { type UserUpdateNodeType } from 'automations/types/nodeTypes';
import { didNodeSyncToServer } from 'automations/utils/node';
import { useMemo } from 'react';

import { type TriggerNodeReturnProps } from './useTriggerNodeConfig';

export default function useUserUpdate(node: NodeProps<UserUpdateNodeType>): TriggerNodeReturnProps {
  const isSyncedToServer = didNodeSyncToServer(node);

  const errorMessages: string[] = [
    !isSyncedToServer && 'Save the node before adding new nodes',
  ].filter(Boolean) as string[];
  const hasErrors = errorMessages.length > 0;

  const AdditionalUI = useMemo(() => <UserUpdateMenu node={node} />, [node]);

  return {
    icon: UserAddOutlined,
    hasErrors,
    errorMessages,
    AdditionalUI,
  };
}
